







































































































import { Component, Vue } from 'vue-property-decorator';
import faker from 'faker';
import get from 'lodash/get';
import SubscriptionPrescriber from '@/models/SubscriptionPrescriber';
import last from 'lodash/last';
import moment from 'moment';
import Sponsorship from '@/models/Sponsorship';
import { postSponsorship } from '@/api/api';
import { saveAs } from 'file-saver';
import { BACKEND_URL } from '@/helpers/constants';
import { postCustomerPrescriber } from '@/api/api';
import Customer from '@/models/Customer';


@Component({
    filters: {
        euro: function(value: number) {
            return new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
            }).format(value);
        },
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        HT: function(value: number) {
            return new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
            }).format(value / 1.2);
        },
    },
})
export default class SponsorshipComponent extends Vue {
    BACKEND_URL = BACKEND_URL;
    form = {
        check: undefined,
        comments: '',
        firstname: '',
        lastname: '',
        phone: '',
        mail: '',
    }

    numberCheck = false;

    loading = false;


    async clickButton() {
        this.loading = true;
        const entity: Sponsorship = {
            firstname: this.form.firstname,
            lastname: this.form.lastname,
            phone: this.form.phone,
            contact_by_prescriber: this.form.check,
            extra_comments: this.form.comments
        };
        postSponsorship(entity)
            .then(data => {
                this.loading = false;
                const $vs = (this as any).$vs;
                this.form = {
                    check: undefined,
                    comments: '',
                    firstname: '',
                    lastname: '',
                    phone: '',
                    mail: ''
                };
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Succès',
                    text: "Contact envoyé à PlugIMMO",
                });
            })
            .catch(error => {
                const $vs = (this as any).$vs;
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: "Une erreur est survenue lors de l'ajout de votre parrainage, veillez à remplir tout les champs obligatoires",
                });
                this.loading = false;
            });
    }


}
